import { Axis, Tooltip, Grid, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption1 = {
  styleId:1,
  pluginName: ["formaterControlLenPlugin"],
  refreshTime: 90000, //间隔刷新时间
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "rectangular" //直角坐标系
  },
  tooltip: new Tooltip("axis", {}),
  grid: new Grid(63, 50, 31, 50, {
    edgeType: "single",
    bottom: 50
  }),
  legend: new Legend({
    top: "top",
    left: "left",
    show: false,
    data: ["数据1"],
    textStyle: { fontSize: 12, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
  }),
  xAxis: new Axis("category", {
    axisLine: { lineStyle: { width: 1, type: "solid", color: "rgba(0, 0, 0, 0.24)" }, show: true },
    inverse: false,
    show: true,
    nameLocation: "end",
    dataValueLength: 100,
    dataValueLengthControl: false,
    name: "",
    splitLine: { lineStyle: { width: 1, type: "solid", color: "rgba(0, 0, 0, 0.24)" }, show: false },
    axisLabel: {
      padding: [0, 0],
      show: true,
      borderRadius: 0,
      interval: 0,
      margin: 20,
      fontSize: 14,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",

      rotate: 0,
      backgroundColor: "rgba(255, 255, 0, 0)",
      axisLabelLen: 10,
      axisLabelLenControl: false,
      formatter: { _custom: { type: "function", display: "<span>ƒ</span> (value, index)" } }
    },
    data: [
      { value: "Mon", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Tue", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Wed", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Thu", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Fri", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Sat", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Sun", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } }
    ],
    axisTick: { alignWithLabel: true },
    nameTextStyle: {
      padding: [0, 0, 0, 0],
      fontSize: 20,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",
      fontFamily: "sans-serif"
    }
  }),
  yAxis: new Axis("value", {
    axisLine: { lineStyle: { width: 1, type: "solid", color: "rgba(0, 0, 0, 0.24)" }, show: true },
    inverse: false,
    show: true,
    nameLocation: "end",
    dataValueLength: 100,
    dataValueLengthControl: false,
    name: "",
    splitLine: { lineStyle: { width: 1, type: "dashed", color: "rgba(0, 0, 0, 0.24)" }, show: false },
    axisLabel: {
      padding: [0, 0],
      show: true,
      borderRadius: 0,
      interval: 0,
      margin: 20,
      fontSize: 14,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",

      rotate: 0,
      backgroundColor: "rgba(255, 255, 0, 0)"
    },
    data: [],
    axisTick: { alignWithLabel: true },
    nameTextStyle: {
      padding: [0, 0, 0, 0],
      fontSize: 20,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",
      fontFamily: "sans-serif"
    }
  }),
  series: [
    {
      label: {
        formatter: "{c}{valueUnit|}",
        show: false,
        rich: {
          valueUnit: { fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
        },
        fontSize: 14,
        fontWeight: "400",

        color: "rgba(0, 0, 0, 0.8)",
        rotate: 0
      },
      symbolSize: 0,
      symbol: "circle",
      animationEasing: "circularOut",
      xAxisIndex: 0,
      type: "line",
      animationEasingUpdate: "circularOut",
      name: "数据1",
      areaStyle: {
        color: {
          colorStops: [
            { offset: 0, color: "rgba(22, 130, 208, 1)" },
            { offset: 1, color: "rgba(0, 228, 228, 0)" }
          ],
          x: 0,
          y: 0,
          y2: 1,
          x2: 0,
          type: "linear"
        }
      },
      lineStyle: {
        width: 4,
        type: "solid",
        color: {
          colorStops: [
            { offset: 0, color: "rgba(27, 142, 191, 1)" },
            { offset: 1, color: "rgba(78, 219, 255, 1)" }
          ],
          x: 0,
          y: 0,
          y2: 1,
          x2: 0,
          type: "linear"
        }
      },
      animationDuration: 1000,
      colorBy: "series",
      data: [
        { value: 10, itemStyle: {} },
        { value: 52, itemStyle: {} },
        { value: 200, itemStyle: {} },
        { value: 334, itemStyle: {} },
        { value: 390, itemStyle: {} },
        { value: 330, itemStyle: {} },
        { value: 220, itemStyle: {} }
      ],
      animationDurationUpdate: 1000,
      smooth: true,
      yAxisIndex: 0,
      animationDelay: { _custom: { type: "function", display: "<span>ƒ</span> (t)" } }
    }
  ],
  dataZoomSet: {
    dataLengthAuto: "all"
  }
}
